export default __webpack_public_path__ + "static/media/008-letters.4c12ed4b.svg";